import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const authApi = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const startLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
